export const determineMerchantId = (item = {}, paymentSettings = {}) => {
  const mode = item.modeOfPayment;
  const isPayrix = item.paymentGateway === 'PAYRIX';
  if (!mode) return undefined;

  let merchantId;
  if (isPayrix) {
    if (mode === 'POS') merchantId = 'posMerchantId';
    else if (mode === 'WEB') merchantId = 'webMerchantId';
  } else if (mode === 'POS') merchantId = 'posForteLocationId';
  else if (mode === 'WEB') merchantId = 'webForteLocationId';
  return paymentSettings[merchantId];
};

export default {};
